module.exports = __webpack_public_path__ + "media/jam_from_oslo.b8629307.mp4";